module.exports = __webpack_public_path__ + "static/img/hdd.5c667ae0.png";